import React from "react";
import { Link } from "react-router-dom";
import Shape from "./Shape";

const PageBanner = ({ pageTitle, link, linkTarget, id }) => {
  return (
    <section
      id={id}
      className="bg-prColor text-light w-full relative overflow-hidden"
    >
      <Shape
        position={{ top: "-20rem", left: "-12rem" }}
        dimension={{ first: "440px", second: "560px", third: "700px" }}
      />
      <div className="container flex flex-col items-center justify-center h-[200px] xs:h-[300px] sm:h-[500px]">
        <h1 className="text-light text-3xl xs:text-4xl sm:text-5xl md:text-6xl font-['Merriweather'] relative cursor-indicator">
          {pageTitle}
        </h1>
        <div className="font-['Poppins'] bg-scColor rounded-full px-8 py-3.5 mt-8 shadow shadow-borderColor">
          <span className="text-dark  text-sm sm:text-lg md:text-xl  mr-2">
            <Link
              to={linkTarget}
              className="hover:text-light mr-2 transition-colors duration-200"
            >
              {link}
            </Link>
            ||{" "}
          </span>
          <span className="text-light text-sm:text-lg md:text-xl ">
            {pageTitle}
          </span>
        </div>
      </div>
      <Shape
        position={{ bottom: "-20rem", right: "-12rem" }}
        dimension={{ first: "440px", second: "560px", third: "700px" }}
      />
    </section>
  );
};

export default PageBanner;
